const {
  i18n: { __ },
  components: { PanelBody, ToggleControl },
  blockEditor: { useSettings },
} = wp;

const FocusableIconSwitcher = ({ enableFocusableIcon, setAttributes }) => {
  const [focusableBlockIcons] =
    useSettings(`custom.focusableBlockIcons`) ?? false;
  return (
    focusableBlockIcons && (
      <>
        <PanelBody
          title={__('Focusable Block Icon', 'b3rg')}
          initialOpen={true}
        >
          <ToggleControl
            label={__('Disable | Enable', 'b3rg')}
            checked={enableFocusableIcon}
            help={__(
              'This feature enables an icon to appear in the top-right corner of the block, allowing you to click on it and focus the block.',
              'b3rg',
            )}
            onChange={() => {
              setAttributes({ enableFocusableIcon: !enableFocusableIcon });
            }}
          />
        </PanelBody>
      </>
    )
  );
};
export default FocusableIconSwitcher;
